import { useEffect, useMemo, useState } from "react";
import { useGetRouletteCategoryThemesQuery } from "../../../../api/rouletteWidgetApi"
import { Box, Button, Card, CardBody, CardFooter } from "grommet";
import RouletteItemCard from "../../strip/RouletteItemCard";
import { SidebarGridSection } from "../sections/SidebarGridSection";
import { rouletteItemBgType, rouletteItemFrameType } from "../../RouletteConstants";

const getBackgroundStyle = (backgroundStyle) => {
    
    let values = {};

    if (backgroundStyle.color) {
        const color = backgroundStyle.color;
        values = { ...values, ...{
            backgroundImage: `linear-gradient(${color.angle}deg, ${color.color1} 0%, ${color.color2} 100%)`
        }};
    }

    if (backgroundStyle.image) {
        const image = backgroundStyle.image;
        values = { ...values, ...{
            backgroundImage: `url('${image.url}')`,
            filter: `hue-rotate(${image.hueRotate}deg) saturate(${image.saturate}%)`,
        }};
    }

    return values;
}

export const RouletteItemThemesTab = ({ backgroudDesignValues, onThemeSelect }) => {

    const { data: themesData, isSuccess: areThemesLoaded } = useGetRouletteCategoryThemesQuery();

    const [themes, setThemes] = useState([]);
    const [selectedTheme, setSelectedTheme] = useState();

    useEffect(() => {
        if (areThemesLoaded) {
            const themesWithPreview = themesData.map(theme => ({ ...theme, ...{ component: <RouletteItemThemePreview designValues={theme} backgroudDesignValues={backgroudDesignValues} /> } }))
            setThemes(themesWithPreview);

            // const themesWithPreview = themesData.map(theme => ({ ...theme, ...{ component: <RouletteItemThemePreview designValues={theme} backgroudDesignValues={backgroudDesignValues} /> } }))
            // const theme1 = {...themesWithPreview[0], ...{ category: { code: 'other', name: 'Other' }}}
            // const theme2 = {...themesWithPreview[0], ...{ category: { code: 'lol', name: 'League of Legends' } }}
            // const theme3 = {...themesWithPreview[0], ...{ category: { code: 'gta', name: 'Grand Theft Auto V' }}}
        
            // setThemes(new Array(5).fill().map(() => themesWithPreview[0]).concat(new Array(2).fill().map(() => theme1)).concat(new Array(1).fill().map(() => theme2)).concat(new Array(7).fill().map(() => theme3)));
        }
    }, [areThemesLoaded])

    return (
        <Box margin={{ top: 'small' }}>
            <SidebarGridSection items={themes} onClick={onThemeSelect} />
        </Box>
    )
}

const RouletteItemThemePreview = ({ designValues, backgroudDesignValues }) => {

    const [cardStyle, setCardStyle] = useState();
    const [borderStyle, setBorderStyle] = useState();
    const [textStyle, setTextStyle] = useState();

    const [backgroundPreviewStyle, setBackgroundPreviewStyle] = useState(getBackgroundStyle(backgroudDesignValues));

    useEffect(() => {
        let cardStyle = {
            size: designValues.backgroundSize,
            radius: designValues.backgroundRadius
        }

        if (designValues.backgroundType === rouletteItemBgType.COLOR) {
            cardStyle = { ...cardStyle, ...{
                color: {
                    color1: designValues.backgroundColor1,
                    color2: designValues.backgroundColor2,
                    angle: designValues.colorGradientAngle
                },
                shadow: {
                    color: designValues.backgroundShadowColor,
                    horizontalOffset: designValues.backgroundShadowHorizontalOffset,
                    verticalOffset: designValues.backgroundShadowVerticalOffset,
                    blur: designValues.backgroundShadowBlur
                }
            }}
        }

        if (designValues.backgroundType === rouletteItemBgType.IMAGE) {
            cardStyle = { ...cardStyle, ...{
                image: {
                    url: designValues.backgroundImage?.url,
                    hueRotate: designValues.backgroundImageHue,
                    saturate: designValues.backgroundImageSaturation
                },
                shadow: {
                    color: designValues.backgroundShadowColor,
                    horizontalOffset: designValues.backgroundShadowHorizontalOffset,
                    verticalOffset: designValues.backgroundShadowVerticalOffset,
                    blur: designValues.backgroundShadowBlur
                }
            }}
        }
        
        setCardStyle(cardStyle);

        let borderStyle = {
            size: designValues.frameSize,
            radius: designValues.frameRadius,
            width: designValues.frameOutlineWidth,
        }

        if (designValues.frameType === rouletteItemFrameType.OUTLINE) {
            borderStyle = { ...borderStyle, ...{
                outline: {
                    color1: designValues.frameColor1,
                    color2: designValues.frameColor2,
                    gradientAngle: designValues.frameColorGradientAngle,
                },
                shadow: {
                    color: designValues.frameShadowColor,
                    horizontalOffset: designValues.frameShadowHorizontalOffset,
                    verticalOffset: designValues.frameShadowVerticalOffset,
                    blur: designValues.frameShadowBlur
                },
            }}
        }

        if (designValues.frameType === rouletteItemFrameType.IMAGE) {
            borderStyle = { ...borderStyle, ...{
                image: {
                    url: designValues.frameImage?.url,
                    hueRotate: designValues.frameImageHue,
                    saturate: designValues.frameImageSaturation
                },
                shadow: {
                    color: designValues.frameShadowColor,
                    horizontalOffset: designValues.frameShadowHorizontalOffset,
                    verticalOffset: designValues.frameShadowVerticalOffset,
                    blur: designValues.frameShadowBlur
                },
            }}
        }

        setBorderStyle(borderStyle);

        setTextStyle({
            font: designValues.font?.name,
            color: designValues.textColor,
            fontWeight: designValues.textStyle[0].selected ? designValues.textStyle[0].value : 'normal',
            fontStyle: designValues.textStyle[1].selected ? designValues.textStyle[1].value : 'normal',
            textDecoration: designValues.textStyle[2].selected ? designValues.textStyle[2].value : 'none',
            textAlign: designValues.textAlignment,
            textTransform: designValues.textTransformation,
            fontSize: designValues.fontSize,
            stroke: {
                width: designValues.fontOutlineWidth,
                color: designValues.textOutlineColor
            },
            shadow: {
                color: designValues.textShadowColor,
                horizontalOffset: designValues.textShadowHorizontalOffset,
                verticalOffset: designValues.textShadowVerticalOffset,
                blur: designValues.textShadowBlur
            },
            lineHeight: designValues.lineHeight,
            letterSpacing: designValues.letterSpacing,
            wordSpacing: designValues.wordSpacing,
            transform: {
                x: designValues.fontPositionX,
                y: designValues.fontPositionY
            },
            fontBlockWidth: designValues.fontBlockWidth,
            textOutlineBackgroundSize: designValues.textOutlineBackgroundSize,
            textOutlineBackgroundColor: designValues.textOutlineBackgroundColor
        })
    }, [designValues])

    const item = useMemo(() => ({ id: "_888", name: 'Visual Check Перевірка Виду' }), []);
    
    return (
        <Box height={'200px'} width={'200px'} style={{ position: 'relative', minHeight: '200px', minWidth: '200px' }} justify="center" align="center" fill={false}>
            <Box style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, minHeight: '200px', minWidth: '200px', ...backgroundPreviewStyle }}></Box>
            <RouletteItemCard item={item} cardStyle={cardStyle} borderStyle={borderStyle} textStyle={textStyle} />
        </Box>
    )
}